import { IoTCoreAdminSystemInfo } from '@/config';
import Axios from 'axios';

export const axiosAdminNoAuth = Axios.create();

// baseURL is set per request rather than at creation time: this module is evaluated
// on import, which happens before the sidecar config fetch resolves, so reading the
// URL here would capture an empty string.
axiosAdminNoAuth.interceptors.request.use((config) => {
  config.baseURL = IoTCoreAdminSystemInfo.URL;
  return config;
});
